var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bottom-wrap nx-flex-center-center"},[_c('van-button',{staticClass:"btn",on:{"click":_vm.openAPP}},[_vm._v("打开北京汽车APP")]),_c('nx-guide',{attrs:{"visible":_vm.show},on:{"update:visible":function($event){_vm.show=$event}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }